<template>
  <div v-if="page && page.templateCode" class="invoice-wrapper">
    <!-- Watermark for draft invoices -->
    <div class="watermark" v-if="page.invoiceable && page.invoiceable.state == 'draft'">BORRADOR</div>

    <component
        :key="componentKey"
        :is="dynamicInvoiceComp"
        :page="page"
        :num_page="num_page"
        :total_pages="total_pages"
    />
  </div>
</template>

<script>
import { getInvoiceViewerDynamicComponent } from "@/modules/shared/infra/DynamicComponent";

export default {
  name: "DynamicInvoiceViewerComponent",
  data() {
    return {
      componentKey: 0,
    }
  },
  props: {
    page: {
      type: Object,
      required: true,
    },
    num_page: {
      type: Number,
      required: true,
    },
    total_pages: {
      type: Number,
      required: true,
    }
  },
  computed: {
    dynamicInvoiceComp() {
      // Get templateCode and options from the page object
      return getInvoiceViewerDynamicComponent(this.page.templateCode, this.page.options); //una mica raro template a page, pero així no cal tocar paginador
    }
  },
  watch: {
    // Force re-render when template or options change
    'page.templateCode'() {
      this.componentKey++;
    },
    'page.options'() {
      this.componentKey++;
    }
  }
};
</script>

<style scoped>
.invoice-wrapper {
    position: relative;
    padding-top: 12mm;
    padding-bottom: 7mm;
}

.watermark {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%) rotate(-45deg);
    font-size: 150px;
    color: rgba(200, 200, 200, 0.3);
    font-weight: bold;
    text-transform: uppercase;
    white-space: nowrap;
    pointer-events: none;
    user-select: none;
    z-index: 1;
}

@media print {

    * {
        -webkit-print-color-adjust:exact !important;
        print-color-adjust:exact !important;
    }

    .logo {
        height: 130px !important;
        width: auto !important;
    }

     .invoiceViewer {
        padding-top: 12mm;
        padding-bottom: 7mm;
        height: 100%;
        box-sizing: border-box;
    }

    .fist__page__padding {
        padding-top: 12mm;
    }

    .page-footer {
        margin-top: auto;
        flex-shrink: 0; /* Don't allow footer to shrink */
    }

    .watermark {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%) rotate(-45deg);
        font-size: 150px;
        color: rgba(200, 200, 200, 0.3);
        font-weight: bold;
        text-transform: uppercase;
        white-space: nowrap;
        pointer-events: none;
        user-select: none;
        z-index: 1;
    }

@page { size: auto;  margin: 0mm; }
}
</style>
